<template>
  <div>
    <new-header title="受访者列表"></new-header>
    <a-card :bordered="false" :head-style="{padding:0}" :body-style="{padding:'10px'}">
      <a-row>
        <a-col :span="18" class="search-panel">
          <a-input class="search-item-com" v-model="queryParam.input" placeholder="请输入编号/姓名" style="width: 200px"></a-input>
          <a-button class="search-item-com" icon="search" shape="circle" @click="searchQuery"  style="margin-left: 10px" ></a-button>
          <a-button class="search-item-com" icon="reload" shape="circle" @click="searchReset" style="margin-left: 10px"></a-button>
        </a-col>
      </a-row>
      <a-table
        size="small"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{ x: 'max-content' }"
        :rowSelection="{selectedRowKeys, onChange: onSelectChange, type: 'checkbox'}"
        :customRow="customRowFn"
        @change="handleTableChange">
        <span slot="status" slot-scope="text, record">
          <a-tag :color="textInfo[text] ?textInfo[text].color:''">{{ textInfo[text] ?textInfo[text].text:'' }}</a-tag>
        </span>
      </a-table>
    </a-card>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {formStatus} from '@/constants/patient'
import NewHeader from '@comp/pad/NewHeader'
  export default {
    name: 'Index',
    components: { NewHeader },
    mixins: [JeecgListMixin],
    data() {
      return {
        textInfo:formStatus,
        disableMixinCreated:true,
        projectId:'',
        url: {
          list: '/patient/patientForm/doingList'
        }
      }
    },
    computed: {
      // 表头
      columns() {
        return [
          {
            title: '受试者编号',
            dataIndex: 'patientNum',
            width: 90,
            align: 'center',
          },
          {
            title: '姓名',
            dataIndex: 'patientName',
            width: 80,
            align: 'center',
          },
          {
            title: '性别',
            dataIndex: 'patientSex',
            width: 60,
            align: 'center',
            customRender:function (text) {
              if (text === '1') {
                return '男'
              } else if (text === '0') {
                return '女'
              } else {
                return text
              }
            }
          },
          {
            title: '年龄',
            dataIndex: 'patientAge',
            width: 60,
            align: 'center',
          },
          {
            title: '研究员',
            dataIndex: 'personName',
            width: 80,
            align: 'center',
          },
        {
          title: '随访周期',
            dataIndex: 'periodItemName',
          width: 100,
          align: 'center',
        },
        {
          title: '随访表单',
          dataIndex: 'name',
          ellipsis: true, //表格省略
          width: 200,
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        // {
        //   title: '缓存状态',
        //     dataIndex: 'cacheStatus',
        //   width: 100,
        //   align: 'center',
        // },
          {
            title: '推送状态',
            dataIndex: 'pushStatus',
            width: 80,
            align: 'center',
            customRender:function (text) {
              if (text === '1') {
                return '已推送'
              } else {
                return '未推送'
              }
            }
          },
          {
            title: '随访截至日期',
            dataIndex: 'periodItemEndDate',
            width: 100,
            align: 'center',
          },
        ]
      },
    },
    mounted(){
      this.projectId = this.$route.query.projectId
      this.baseQueryParam.projectId = this.projectId
      if(this.$route.query.delay==='1'){
        this.url.list = '/patient/patientForm/getOverdueFrom'
      }
      this.loadData()
    },
    methods:{
      customRowFn(record) {
        return {
          on: {
            click: () => {
              this.$router.push({path:`/pad/patient/registerform/${record.id}`})
            }
          }
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .search-panel{
    padding: 10px 0;
  }
</style>